const appContent = {}; // dynamically filled by `appContentInitialiser` during bootstrap

export default appContent;
